// extracted by mini-css-extract-plugin
export default {"root":"page_preview___root___c973efa7","wrap":"page_preview___wrap___d3cdf672","page":"page_preview___page___af258143","slide":"page_preview___slide___fce87f70"};